



















































































import CommonButton from '@/components/button/CommonButton.vue';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';

import Component from 'vue-class-component';
import { Mixins } from 'vue-property-decorator';
import {
  CodeRetrieveResponse, SubmissionCommentRevision, SubmissionCommentRevisionResponse, SubmissionCommentUpdateDialogRequest
} from '@/model/CommonModel';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import '@/plugins/Modal';
import TextInput from '@/components/input/TextInput.vue';
import CommonPaginatedTable from '@/components/table/CommonPaginatedTable.vue';
import DataTable from '@/components/table/DataTable.vue';
import SubmissionApi from '@/api/SubmissionApi';
import MessageUtils from '@/utils/MessageUtils';
import DefaultFormMixin from '@/views/DefaultFormMixin';
import SelectInput from '@/components/input/SelectInput.vue';
import StringUtils from '@/utils/StringUtils';
import ScrollableDataTable from '@/components/table/ScrollableDataTable.vue';

@Component({
  components: {
    ScrollableDataTable,
    SelectInput,
    CommonButton,
    CommonPromptDialog,
    TextInput,
    CommonPaginatedTable,
    DataTable,
  },
  mixins: [DialogEventsMixin, DefaultFormMixin],
})
export default class SubmissionCommentUpdateDialog extends Mixins(DialogEventsMixin, DefaultFormMixin) {
  private dialogVisible: boolean = false;
  private comments: string = '';
  private originComments: string = '';
  private status: string = '';
  private originBatchStatus: string = '';
  private changeableStatus: boolean = false;

  private revisions: SubmissionCommentRevision[] = [];
  private batchKey: number = 0;
  private onConfirm: (() => void) | undefined;
  private manualBatchStatusOptions: CodeRetrieveResponse[] = [];

  protected DEFAULT_LABEL_WIDTH = `130px`;

  get isVisible() {
    return this.dialogVisible;
  }

  get isStatusOptionDisabled() {
    return !this.changeableStatus;
  }

  get getManualBatchStatusOptions() {
    return this.manualBatchStatusOptions;
  }

  public mounted() {
    this.$modal
        .getEventBus()
        .$on('showSubmissionCommentUpdateDialog', (params: SubmissionCommentUpdateDialogRequest) => {
          this.loading = false;
          this.show(params);
        });

    this.$modal.getEventBus().$on('hideSubmissionCommentUpdateDialog', () => this.cancel());
  }

  public onOpened() {
    const refs = (this.$refs.comments as any);
    if (refs && refs.focus instanceof Function) {
      refs.focus(100);
    }
  }

  public show(params: SubmissionCommentUpdateDialogRequest) {
    const {batchKey, onConfirm} = params;
    this.batchKey = batchKey;
    this.onConfirm = onConfirm;

    SubmissionApi.retrieveSubmissionCommentRevisions(this.$route.params.sponsorKey, this.batchKey)
                 .then((res: SubmissionCommentRevisionResponse) => {
                   this.dialogVisible = true;
                   const {revisions, manualBatchStatusOptions, changeableStatus, originBatchStatus} = res.data;
                   this.comments = revisions && revisions.length > 0 ? revisions[0].comments : '';
                   this.originComments = this.comments;
                   this.revisions = revisions;
                   this.manualBatchStatusOptions = manualBatchStatusOptions;
                   this.changeableStatus = changeableStatus;
                   this.originBatchStatus = originBatchStatus;
                 });
  }

  public confirm() {
    if (this.comments === this.originComments && !StringUtils.hasValue(this.status)) {
      this.hide();
      return;
    }

    this.loading = true;
    const params = {
      comments: this.comments,
      batchStatus: this.status,
      originBatchStatus: this.originBatchStatus,
    };

    SubmissionApi.updateSubmissionCommentRevisions(this.$route.params.sponsorKey, this.batchKey, params)
                 .then((res: SubmissionCommentRevisionResponse) => {
                   if (res.success) {
                     MessageUtils.displaySuccessMessage(this.$t('message.success').toString());
                   } else {
                      return Promise.reject(res.errMsg);
                   }
                   return new Promise(resolve => {
                     setTimeout(() => {
                       resolve();
                     }, 1000);
                   });
                 })
                 .then(() => {
                   this.afterSuccessToUpdateComment();
                 })
                 .catch((errMsg: string) => this.afterRequestFail(errMsg))
                 .finally(() => {
                   this.loading = false;
                   this.hide();
                 });
  }

  private afterSuccessToUpdateComment() {
    if (this.onConfirm instanceof Function) {
      this.onConfirm();
    }
  }

  public cancel() {
    this.hide();
  }

  public hide() {
    this.dialogVisible = false;

  }

  public onClosed() {
    this.loading = false;
    this.comments = '';
    this.status = '';
  }

  public destroyed() {
    this.$modal.getEventBus().$off('showSubmissionCommentUpdateDialog');
    this.$modal.getEventBus().$off('hideSubmissionCommentUpdateDialog');
  }
}
